// extracted by mini-css-extract-plugin
export var standaloneTable = "_et-0";
export var withExtraHeader = "_et-1";